/* eslint-disable import/no-anonymous-default-export */
export default {
  ABOUT_US: "/about-us",
  DEFAULT: "/",
  DASHBOARD: {
    ACCOUNT_SETTINGS: "/dashboard/account-settings",
    DEFAULT: "/dashboard",
    HELP: "/dashboard/help",
    USERS: "/dashboard/users",
  },
  ENROLL: "/enroll",
  INSTRUCTORS: "/instructors",
  LIFEGUARDS: "/lifeguards",
  PRIVACY_POLICY: "/privacy-policy",
  REVIEWS: "/reviews",
  SERVICE_AREA: "/service-area",
  SERVICES: "/services",
  TERMS_AND_CONDITIONS: "/terms-and-contditions",
};
